import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import {
	DeviceLicense,
	DeviceLicenseWarningDetails,
	DeviceLicenseState
} from '@shure/shared/angular/data-access/system-api/models';
import { provideInlineScope } from '@shure/shared/angular/utils/i18n';

import { LicenseStateTitlePipe } from '../../../pipes';

@Component({
	selector: 'sh-device-license-state-icon',
	standalone: true,
	imports: [CommonModule, TranslocoModule, LicenseStateTitlePipe],
	providers: [provideInlineScope('scDeviceLicense', (lang) => import(`../../../../i18n/${lang}`))],
	templateUrl: './device-license-state-icon.component.html',
	styleUrls: ['./device-license-state-icon.component.scss']
})
export class DeviceLicenseStateIconComponent {
	@Input() public warningTemplateRef!: TemplateRef<{ tooltip: string; onClick: () => void }>;
	@Input() public errorTemplateRef!: TemplateRef<{ tooltip: string; onClick: () => void }>;
	@Input() public deviceLicense!: DeviceLicense<DeviceLicenseWarningDetails>;

	@Output() public readonly licenseIconClick = new EventEmitter<Event>();

	protected readonly deviceLicenseStateEnum = DeviceLicenseState;

	public onClick = (event: Event): void => {
		this.licenseIconClick.emit(event);
	};
}
